import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useToast } from '../hooks/use-toast';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      toast({
        title: "Success!",
        description: "You've been subscribed to our newsletter.",
      });
      setEmail('');
    }
  };

  return (
    <section className="bg-gradient-to-b from-[#0a0a0a] to-black py-28 luxury-texture">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#C9A55A]/10 rounded-full mb-8 border border-[#C9A55A]/20">
            <Mail className="text-[#C9A55A]" size={36} />
          </div>
          <h2 className="luxury-heading text-4xl md:text-5xl text-white mb-6">
            Stay Informed
          </h2>
          <p className="text-gray-400 text-lg mb-10 leading-relaxed">
            Subscribe to receive our latest insights, industry trends, and expert analysis delivered to your inbox.
          </p>
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-white/5 border-white/10 text-white placeholder:text-gray-500 focus:border-[#C9A55A] h-14 smooth-transition"
              required
            />
            <Button 
              type="submit"
              className="luxury-button bg-[#C9A55A] text-black hover:bg-[#B8941F] font-semibold h-14 px-10 smooth-transition shadow-lg"
            >
              Subscribe
            </Button>
          </form>
          <p className="text-gray-600 text-xs mt-6">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;